import React, { useState } from 'react';
import './ImageUploadModal.css';
import ConfirmationModal from '../modals/ConfirmationModal';

const ImageUploadModal = ({
  show,
  onClose,
  selectedColor,
  uploadingImages,
  onFileChange,
  onStartUploading,
  onRetryUpload,
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  if (!show) return null;

  const handleClose = () => {
    const hasPendingImages = uploadingImages.some(img => img.status === 'pending');
    if (hasPendingImages) {
      setShowConfirmModal(true);
      return;
    }
    onClose();
  };

  const handleConfirmClose = () => {
    setShowConfirmModal(false);
    onClose();
  };

  const handleCancelClose = () => {
    setShowConfirmModal(false);
  };

  const handleFileChange = (e) => {
    setIsProcessing(true);
    onFileChange(e);
    // Reset processing state after a short delay to allow images to render
    setTimeout(() => {
      setIsProcessing(false);
    }, 1000);
  };

  return (
    <>
      <div className="modal-overlay">
        <div className="modal-content">
          {/* Modal Header */}
          <div className="upload-modal-header">
            <h4>Upload Images - {selectedColor?.name}</h4>
          </div>

          {/* Modal Body */}
          <div className="modal-body">
            {/* File Input Section */}
            {uploadingImages.length === 0 && (
              <div className="file-input-section">
                <input
                  type="file"
                  accept=".png,.jpg,.jpeg,image/png,image/jpg,image/jpeg"
                  multiple
                  onChange={handleFileChange}
                />
              </div>
            )}

            {/* Images List */}
            {isProcessing ? (
              <div className="loading-indicator">
                <div className="loading-spinner"></div>
                <p>Processing images...</p>
              </div>
            ) : (
              <div className="images-list">
                {uploadingImages.map((image, index) => (
                  <div key={index} className="image-item">
                    {/* Image Preview */}
                    {image.base64 && (
                      <img
                        src={image.base64}
                        alt={image.name}
                      />
                    )}

                    {/* Image Info */}
                    <div className="image-info">
                      <div className="image-name">{image.name}</div>

                    </div>
                    {
                      image.status !== 'failed' && (
                        <div className={`image-status ${image.status}`}>
                          {image.status === 'pending' && 'Pending'}
                          {image.status === 'uploading' && 'Uploading...'}
                          {image.status === 'uploaded' && 'Uploaded'}
                          {image.status === 'failed' && 'Failed'}
                        </div>
                      )
                    }
                    {/* Action Buttons */}
                    <div className="image-actions">
                      {image.status === 'failed' && (
                        <button
                          type="button"
                          onClick={() => onRetryUpload(index)}
                          className="image-upload-retry-btn"
                        >
                          Retry
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Modal Footer */}
          <div className="modal-footer">
            {
              uploadingImages?.length > 0 && (
                <button
                  type="button"
                  onClick={onStartUploading}
                  className="start-upload-btn"
                  disabled={uploadingImages.some(img => img.status === 'uploaded')}
                >
                  Upload
                </button>
              )
            }
            <button
              type="button"
              onClick={handleClose}
              className="cancel-btn"
            >
              Close
            </button>
          </div>
        </div>
      </div>

      <ConfirmationModal
        visible={showConfirmModal}
        title="Confirm Close"
        message="There are some images that are pending to upload. Are you sure you want to close?"
        confirmText="Close"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />
    </>
  );
};

export default ImageUploadModal;
